document.addEventListener('DOMContentLoaded', function(dom) {
  const accordions = dom.target.querySelectorAll('.accordion-item')

  accordions.forEach((accordion) => {
    accordion.addEventListener('show.bs.collapse', function(event) {
      event.target.closest('.accordion-item').classList.add('open')
    })

    accordion.addEventListener('hide.bs.collapse', function(event) {
      event.target.closest('.accordion-item').classList.remove('open')
    })
  })
})
